<template>
    <div class="clearfix userCenterView enterpriseCertification">
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">企业认证</div>
            <div class="content">
                <div class="step">
                    <div class="step1" :class="is_active===1?'is_active':''"><i class="stepNum" :class="is_active===1?'':'colorGray'">1</i>填写企业认证信息</div>
                    <div class="el-icon-caret-right" :class="is_active===1?'colorBlue':''"></div>
                    <div class="el-icon-caret-right white"></div>
                    <div class="step2" :class="is_active===2?'is_active':''"><i class="stepNum" :class="is_active===2?'':'colorGray'">2</i>等待管理员审核</div>
                    <div class="el-icon-caret-right" style="left: 560px;" :class="is_active===2?'colorBlue':''"></div>
                    <div class="el-icon-caret-right white" style="left: 562px;"></div>
                    <div class="step3" :class="is_active===3?'is_active':''"><i class="stepNum" :class="is_active===3?'':'colorGray'">3</i>查看认证审核结果</div>
                </div>
                <div class="editCertification" v-if="is_active === 1 || is_active === 5">
                    <EditCertification :data="formValue" :isApply="is_apply" @submit="getCertificatesSave" />
                </div>
                <div class="waitCertification" v-if="is_active === 2">
                    <WaitCertification :data="formValue" @withdrawSuccess='getCertificatesSave' />
                </div>
                <div class="waitCertification" v-if="is_active === 3">
                    <CertificationPass :data="formValue" @withdrawSuccess='getCertificatesSave' />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index.vue'
import EditCertification from './editCertification'
import WaitCertification from './waitCertification'
import CertificationPass from './certificationPass'
import { UserCenterService } from '../../../service/userCenter.service'
export default {
    components: {Bread,EditCertification,WaitCertification,CertificationPass},
    data() {
        return {
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '企业认证',
                path: '/userCenter/enterpriseCertification'
            }],
            is_active: 1,
            is_apply: 0,
            formValue: {}
        }
    },
    methods: {
        // data.is_apply    0：未申请，1：待审核，2：审核通过，3：审核拒绝，4：撤回
        async getCertificatesSave() {
            const data = await UserCenterService.getCertificatesSave()
            this.is_apply = data.is_apply;
            switch(data.is_apply) {
                case 0 :
                    this.is_active = 1
                    break
                case 3 :
                    this.is_active = 1
                    break
                case 4 :
                    this.is_active = 1
                    break
                case 5 :
                    this.is_active = 1
                    break
                case 1 :
                    this.is_active = 2
                    break
                case 2 :
                    this.is_active = 3
                    break
            }
            this.formValue = JSON.parse(JSON.stringify(data))
        },
        changeActive(val) {
            this.is_active = val
        }
    },
    created() {
        this.getCertificatesSave()
    },
    destroyed() {
        // location.reload()
    }
}
</script>

<style lang="scss" scoped>
    @mixin Triangle($left) {
        font-size: 56px;
        position: absolute;
        left: $left;
        background: transparent;
        top: -10px;
        width: 33px;
        padding: 0;
    }
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 30px 50px 30px;
            border: 1px solid #e3e2e1;
            display: block;
        }
    }
    .enterpriseCertification{
        
        .step{
            width: 875px;
            margin: 30px auto;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            text-align: center;
            font-size: 15px;
            position: relative;
            >div{
                width: 33%;
                background: #ccc;
                padding: 6px 0;
                color: #fff;
                position: relative;
                z-index: 1;
                >i{
                    font-style: normal;
                    background: #fff;
                    color: #1d90d0;
                    width: 23px;
                    height: 23px;
                    line-height: 23px;
                    border-radius: 18px;
                    margin-right: 15px;
                    display: inline-block;
                }
                >i.colorGray{
                    color: #ccc;
                }
            }
            >div.is_active{
                background: #1d90d0;
            }
            >div.el-icon-caret-right{
                @include Triangle(269px);
                z-index: 3;
                color: #ccc;
            }
            >div.el-icon-caret-right.colorBlue{
                color: #1d90d0;
            }
            >div.el-icon-caret-right.white{
                z-index: 2;
                @include Triangle(271px);
                color: #fff;
            }
        }
    }
</style>